import api from "../../Http/global-vars";
import { FETCH_INCUBATEURS } from "../types";
import axios from "axios";

export const fetchIncubateurs = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "create_incubateur/";
    await axios
      .get(url, config)
      .then(async (res) => {
        dispatch({
          type: FETCH_INCUBATEURS,
          payload: res?.data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
